import { ApiServiceV1 } from '@services/api.service';

import { minifyJSONFromStr } from '@helpers';

export default {
  async getApplications({ activeOnly = true }) {
    const { data } = await ApiServiceV1.get('service', {
      params: {
        activeOnly,
      },
    });
    return data || [];
  },

  async getApplicationUsers({ app }) {
    const { data } = await ApiServiceV1.get(`service/${app}/user`);
    return data || [];
  },

  addUserToApplication({ app, data }) {
    return ApiServiceV1.post(`service/${app}/user`, data);
  },

  removeUserFromApplication({ app, data }) {
    return ApiServiceV1.delete(`service/${app}/user`, { data });
  },

  async getApplicationHistory({ app, pageNum: pageNumber = 1, pageSize = 10 }) {
    const { data: { items } } = await ApiServiceV1.get(`service/${app}/history`, {
      params: {
        pageNumber,
        pageSize,
      },
    });
    return items || [];
  },

  createApplication({ data }) {
    return ApiServiceV1.post('service', {
      name: data.name,
      password: data.password,
      loginTypes: data.loginTypes,
      tokenLifetime: data.tokenLifetime,
      description: data.description || null,
      azureAppBody: minifyJSONFromStr(data.azureAppBody),
    });
  },

  updateApplication({ name, data }) {
    return ApiServiceV1.put(`service/${name}`, {
      loginTypes: data.loginTypes,
      tokenLifetime: data.tokenLifetime,
      azureAppBody: minifyJSONFromStr(data.azureAppBody),
    });
  },

  createRole({ app, role: name }) {
    return ApiServiceV1.post(`service/${app}/role`, { name });
  },

  updateRole({ app, oldRole, newRole: name }) {
    return ApiServiceV1.put(`service/${app}/role/${oldRole}`, { name });
  },

  changeApplicationPassword({ name, password }) {
    return ApiServiceV1.put(`service/${name}/password`, { password });
  },

  updateApplicationState({ name, state }) {
    return ApiServiceV1.put(`service/${name}/state`, { state });
  },

  async generateLongtimeToken({ app, roles, lifeTimeDays }) {
    const { data: { access_token: token = '' } } = await ApiServiceV1.post(`service/${app}/token`, {
      roles,
      lifeTimeDays,
    });

    return token;
  },
};
